import { InjectionToken } from '@angular/core';
import { IDfConfig } from '@df/core/df-core.config';
import { TClientMode } from '@df/core/service/client';
import { Nexus } from '@tomandco/nexus-api-types';

export const WINDOW = new InjectionToken<NDfDomGlobals.Window | Window>('df-dom-window');
export const DOCUMENT = new InjectionToken<NDfDomGlobals.Document | Document>('df-dom-document');

export namespace NDfDomGlobals {
    export interface Window {
        // DF Core extension
        dfConfig: IDfConfig;

        autoInitData?: {
            website: Nexus.Lib.General.AppData;
        };
        // standard elements
        document: Document;
        innerWidth: number;
        innerHeight: number;
        navigator: {
            userAgent: string;
        };
        location: {
            hash: string;
            host: string;
            hostname: string;
            href: string;
            origin: string;
            pathname: string;
            protocol: string;
            search: string;
        };
        history: {
            replaceState(): void;
            pushState(): void;
            go(): void;
            back(): void;
        };
        CustomEvent: () => any;
        addEventListener(): void;
        removeEventListener(): void;
        getComputedStyle(): {
            getPropertyValue(): string;
        };
        Image(): void;
        Date(): void;
        screen: {};
        setTimeout(): void;
        clearTimeout(): void;
        matchMedia(): {};
        requestAnimationFrame(callback: any): number;
        cancelAnimationFrame(id: any): void;

        ssr?: {
            mode: TClientMode;
        };
    }

    export interface Document {
        body: {};
        addEventListener(): void;
        removeEventListener(): void;
        activeElement: {
            blur(): void;
            nodeName: string;
        };
        querySelector(): any;
        querySelectorAll(): any[];
        getElementById(): any;
        createEvent(): {
            initEvent(): void;
        };
        createElement(): {
            children: any[];
            childNodes: any[];
            style: {};
            setAttribute(): void;
            getElementsByTagName(): any[];
        };
        createElementNS(): {};
        importNode(): any;
        location: {
            hash: string;
            host: string;
            hostname: string;
            href: string;
            origin: string;
            pathname: string;
            protocol: string;
            search: string;
        };
    }
}
